module.exports = "<app-mapped-attribute-msn></app-mapped-attribute-msn>"